{
  "nav": {
    "home": "Home",
    "services": "Dienste",
    "prices": "Preise",
    "projects": "Projekte",
    "about": "Über mich",
    "contact": "Kontakt",
    "email": "Email",
    "linkedin": "LinkedIn"
  },
  "backToProjects": "Zurück zu Projekten",
  "projectOverview": "Projektübersicht",
  "overview": "Übersicht",
  "challenge": "Die Herausforderung",
  "businessNeed": "Das Geschäftsbedürfnis",
  "philosophy": "Die Philosophie",
  "goal": "Das Ziel",
  "solution": "Die Lösung",
  "polestarLandingPage": "Polestar Live Landingpage"
}
